<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Caption',
              modelPath: [this, 'form', 'caption'],
              multilingual: true
            }),
            new fields.Image({
              label: 'Image',
              modelPath: [this, 'form', 'image'],
              required: true,
              onlyShowNormalCrop: true,
              defaultThumbnail: !this.form.use_crop
            }),
            new fields.Switch({
              label: 'Use cropping',
              modelPath: [this, 'form', 'use_crop']
            })
          ]
        }
      ]
    }
  }
}
</script>
